import { useAlert } from '../../../../../../ui/features/alerts';
import { useAlertUiTranslation } from '../../../../../../ui/hooks';
export function useAlertTemplateBadge(templateId) {
    const { t } = useAlertUiTranslation();
    const { data, isLoading, error } = useAlert(templateId !== null && templateId !== void 0 ? templateId : '', false);
    let alertTemplateBadgeLabel = undefined;
    if (data && !isLoading) {
        if (data.title) {
            alertTemplateBadgeLabel = data.title;
        }
    }
    else if ((error === null || error === void 0 ? void 0 : error.status) === 404) {
        alertTemplateBadgeLabel = t('common.templateDeleted');
    }
    return alertTemplateBadgeLabel;
}
